import { useState } from 'react';
import { useAuthContext } from 'src/auth/useAuthContext';
import CloseButton from '../img/CloseButton';
import { cn } from '../../lib/utils';
import NetPromoterScoreForm from './NetPromoterScaleForm';
import { setIgnoreNps, shouldIgnoreNps } from './ignoreNpsStorage';

type NetPromoterScoreProps = {
  showOnLoad: boolean;
  /** Current Salesforce send; dismissals from before this send do not suppress the banner. */
  npsLastSendDate: Date;
};

const NetPromoterScore = ({ showOnLoad, npsLastSendDate }: NetPromoterScoreProps) => {
  const { user } = useAuthContext();
  const userUuid = typeof user?.uuid === 'string' ? user.uuid : '';

  // Read once on mount so a close-button dismiss can still animate out.
  // Salesforce last-send / opt-out gating remains in the layout — this only covers ignoreNPS.
  const [ignoredOnLoad] = useState(() => shouldIgnoreNps(userUuid, npsLastSendDate));
  const [open, setOpen] = useState(() => showOnLoad && !ignoredOnLoad);

  if (ignoredOnLoad) {
    return null;
  }

  // Close/X: local escalating ignore only — does not touch Salesforce opt-out / last-send.
  const handleClose = () => {
    setIgnoreNps(userUuid);
    setOpen(false);
  };

  return (
    <div
      className={cn(
        'fixed bottom-0 right-0 sm:bottom-2.5 sm:right-2.5 w-full max-w-[600px] sm:w-4/5 md:w-3/5 lg:w-2/5 z-50',
        'rounded-t-xl sm:rounded-xl border bg-card p-4 pr-10 text-card-foreground shadow-2xl',
        'transition-all duration-300 ease-out',
        open ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-full opacity-0'
      )}
    >
      <CloseButton
        onClose={handleClose}
        className="absolute right-2 top-2 h-8 w-8 p-0 text-muted-foreground hover:text-foreground"
      />
      <NetPromoterScoreForm onScoreSelected={() => setOpen(false)} />
    </div>
  );
};

export default NetPromoterScore;
